import React, { useState } from "react";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";

const Skills = () => {
  const [counterOn, setCounterOn] = useState(false);

  const skills = {
    Web: [
      { name: "React", percent: 90 },
      { name: "Node JS", percent: 70 },
      { name: "Express JS", percent: 80 },
      { name: "MongoDB", percent: 75 },
      { name: "Next.JS", percent: 85 },
      { name: "MySQL", percent: 30 },
    ],
    Others: [
      { name: "React Native", percent: 85 },
      { name: "GraphQL", percent: 80 },
      { name: "Redux", percent: 80 },
      { name: "Redux Toolkit", percent: 80 },
    ],
    Programming: [
      { name: "JavaScript", percent: 90 },
      { name: "C", percent: 60 },
      { name: "PHP", percent: 50 },
    ],
    Tools: [
      { name: "Git", percent: 90 },

      { name: "VS Code", percent: 90 },
    ],
  };

  const skillsName = Object.keys(skills);
  const [selectedSkill, setSelectedSkill] = useState(skillsName[0]);
  const selectedSkills = skills[selectedSkill];

  return (
    <div className="px-10 py-10" data-aos="zoom-in" data-aos-duration="1500">
      <h1 className="text-5xl text-white font-extrabold uppercase mb-20 text-center">
        My
        <span className="text-primary"> Skills</span>
      </h1>

      <div className="text-center">
        <div className="p-5">
          <div className="flex justify-center items-baseline flex-wrap">
            <button
              onClick={() => setSelectedSkill("Web")}
              className={`tabBtn start ${
                "Web" === selectedSkill ? "active" : ""
              }`}
            >
              Web
            </button>
            <button
              onClick={() => setSelectedSkill("Programming")}
              className={`tabBtn middle ${
                "Programming" === selectedSkill ? "active" : ""
              }`}
            >
              Programming
            </button>
            <button
              onClick={() => setSelectedSkill("Others")}
              className={`tabBtn middle ${
                "Others" === selectedSkill ? "active" : ""
              }`}
            >
              Others
            </button>
            <button
              onClick={() => setSelectedSkill("Tools")}
              className={`tabBtn last ${
                "Tools" === selectedSkill ? "active" : ""
              }`}
            >
              Tools
            </button>
          </div>
        </div>
      </div>
      {/* skills Cards */}
      <ScrollTrigger
        onEnter={() => setCounterOn(true)}
        onExit={() => setCounterOn(false)}
      >
        <div className="grid lg:grid-cols-2 gap-5 mt-12">
          {selectedSkills.map(({ name, percent }) => (
            <div
              key={name}
              className="relative bg-bgPrimary  py-[25px] pl-[35px] pr-[25px]"
            >
              <h4 className="text-xl font-extrabold">{name}</h4>
              <p className="absolute rounded bgLinear px-2 py-1  top-[25px] right-[15px] font-bold">
                {counterOn && <CountUp end={percent} />}%
              </p>
              <div
                style={counterOn
                  ? {
                      width: `${percent}%`,
                      animationDelay: '0.8s',
                      animation: 'progress 2s ease-in-out forwards',
                    }
                  : {}}
               
                className="progress-ar bgLinear h-3 rounded  mt-8 "
                
              />
               
            </div>
          ))}
        </div>
      </ScrollTrigger>
    </div>
  );
};

export default Skills;
